import { ExtendedColumnDef } from "@/interfaces/globals";

export type TProjectDetail = {
  customerName: string;
  projectName: string;
  address: string;
};

export type TResourceRecovery = {
  material: string;
  reuse: number;
  recycle: number;
  landfill: number;
  energyRecovery: number;
  totalByMaterial: number;
  recoveryByMaterial: number;
  compositionByMaterial: number;
};

export type TWasteVolume = {
  id?: string;
  loadType: string;
  quantity: number;
};

type TRecoveryBreakdown = {
  loadType: string;
  loadQuantity: number;
  wasteType: string;
  totalWasteWeight: number;
  netWasteWeight: number;
  recycledWasteWeight: number;
  recycledMaterials: string[];
  recyclingPercentage: number;
};

export const projectColumns: ExtendedColumnDef<TProjectDetail>[] = [
  {
    accessorKey: "customerName",
    header: "Customer Name",
  },
  {
    accessorKey: "projectName",
    header: "Project Name",
  },
  {
    accessorKey: "address",
    header: "Address",
  },
];

export const recoveryColumns: ExtendedColumnDef<TResourceRecovery>[] = [
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate")
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label="Select all"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label="Select row"
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },

  {
    accessorKey: "material",
    header: "Material",
    cell: ({ row }): React.JSX.Element => {
      const value: string = row.getValue("material");

      return <div className='break-all'>{value}</div>;
    },
  },
  {
    accessorKey: "reuse",
    header: "Reuse/Resale",
    cell: ({ row }): React.JSX.Element => {
      return <div>{row?.getValue("reuse")}</div>;
    },
  },
  {
    accessorKey: "recycle",
    header: "Recycle",
    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("recycle")).toFixed(2);

      return <div>{fixedValue}</div>;
    },
  },
  {
    accessorKey: "energyRecovery",
    header: "Energy Recovery",
    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("energyRecovery")).toFixed(2);

      return <div>{fixedValue}</div>;
    },
  },
  {
    accessorKey: "landfill",
    header: "landfill",
    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("landfill")).toFixed(2);

      return <div>{fixedValue}</div>;
    },
  },
  {
    accessorKey: "totalByMaterial",
    header: "Total by material",
    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("totalByMaterial")).toFixed(2);

      return <div>{fixedValue}</div>;
    },
  },
  {
    accessorKey: "recoveryByMaterial",
    header: "Recovery By Material (%)",

    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("recoveryByMaterial")).toFixed(0);

      return <div>{fixedValue} %</div>;
    },
  },
  {
    accessorKey: "compositionByMaterial",
    header: "Composition By Material (%)",
    cell: ({ row }): React.JSX.Element => {
      const fixedValue = Number(row?.getValue("compositionByMaterial")).toFixed(
        0,
      );

      return <div>{fixedValue} %</div>;
    },
  },
];

recoveryColumns?.forEach((column) => {
  column.enableSorting = false;
});

export const wasteVolumeColumns: ExtendedColumnDef<TWasteVolume>[] = [
  // {
  //   id: "select",
  //   header: ({ table }) => (
  //     <Checkbox
  //       checked={
  //         table.getIsAllPageRowsSelected() ||
  //         (table.getIsSomePageRowsSelected() && "indeterminate")
  //       }
  //       onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
  //       aria-label='Select all'
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <Checkbox
  //       checked={row.getIsSelected()}
  //       onCheckedChange={(value) => row.toggleSelected(!!value)}
  //       aria-label='Select row'
  //     />
  //   ),
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  {
    accessorKey: "loadType",
    header: "Load type",
    enableSorting: false,
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    cell: ({ row }): React.JSX.Element => {
      const value: number = row.getValue("quantity");

      return <div>{value.toFixed(2)}</div>;
    },
    enableSorting: false,
  },
];

export const recoveryBreakdownColumns: ExtendedColumnDef<TRecoveryBreakdown>[] =
  [
    {
      accessorKey: "loadType",
      header: "Load type",
      cell: ({ row }) => (
        <div className='line-clamp-2 max-w-[250px]'>
          {row.original.loadType}
        </div>
      ),
    },
    {
      accessorKey: "loadQuantity",
      header: "Load Qty",
      cell: ({ row }): React.JSX.Element => {
        const value: number = row.getValue("loadQuantity");

        return <div>{value?.toFixed(2)}</div>;
      },
    },
    {
      accessorKey: "wasteType",
      header: "Waste type",
      cell: ({ row }): React.JSX.Element => {
        const value: string = row.getValue("wasteType");

        return <div className='tracking-wider uppercase'>{value}</div>;
      },
    },
    {
      accessorKey: "totalWasteWeight",
      header: "Total Weight",
      cell: ({ row }): React.JSX.Element => {
        const value: number = row.getValue("totalWasteWeight");

        return <div>{value?.toFixed(2)}</div>;
      },
    },
    {
      accessorKey: "netWasteWeight",
      header: "Net Weight",
      cell: ({ row }): React.JSX.Element => {
        const value: number = row.getValue("netWasteWeight");

        return <div>{value?.toFixed(2)}</div>;
      },
    },
    {
      accessorKey: "recycledWasteWeight",
      header: "Recycled Waste",
      cell: ({ row }): React.JSX.Element => {
        const value: number = row.getValue("recycledWasteWeight");

        return <div>{value?.toFixed(2)}</div>;
      },
    },
    {
      accessorKey: "recycledMaterial",
      header: "Recycled Material",
      cell: ({ row }): string => {
        return row.original.recycledMaterials?.map((item) => item).join(", ");
      },
    },
    {
      accessorKey: "recyclingPercentage",
      header: "Recycling %",
      cell: ({ row }): React.JSX.Element => {
        const value: number = row.getValue("recyclingPercentage");

        return <div>{value?.toFixed(2)} %</div>;
      },
    },
  ];

recoveryBreakdownColumns?.forEach((column) => {
  column.enableSorting = false;
});
